import type * as FirebaseAuth from "firebase/auth"
import { useState } from "react"
import type { UserDocument } from "popopo-msg"
import { useForm } from "react-hook-form"
import { api } from "../../core"

type VirtualCastOAuthAuthCodeForms = {
  redirectUri: string
}

// デバッグページと同一オリジン配下に配置されたコールバックに戻すため、
// 現在の origin から redirect_uri を組み立てる（localhost:3001, popopo-${env}-web.web.app など全環境で同じ導出ロジックが使える）
const redirectUri = `${window.location.origin}/oauth/virtualcast/callback`

export const VirtualCastOAuthAuthCodeForm = (props: { firebase: FirebaseAuth.User; user: UserDocument }) => {
  const [authURL, setAuthURL] = useState<string>()
  const form = useForm<VirtualCastOAuthAuthCodeForms>({
    mode: "onBlur",
    defaultValues: {
      redirectUri,
    },
  })

  const { isSubmitting, isValid } = form.formState

  const onSubmit = async (value: VirtualCastOAuthAuthCodeForms) => {
    try {
      const idToken = await props.firebase.getIdToken()
      const response = await api.POST("/api/v2/users/me/oauth/virtualcast/auth-code", {
        headers: {
          authorization: `Bearer ${idToken}`,
        },
        body: {
          redirectUri: value.redirectUri,
        },
      })
      if (response.data === undefined) {
        console.error(`invalid response: ${JSON.stringify(response.error)}`)
        return
      }
      setAuthURL(response.data.url)
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <>
      {authURL && (
        <div className="text-center" style={{ wordBreak: "break-word" }}>
          <h6>Generated!</h6>
          <a href={authURL}>{authURL}</a>
        </div>
      )}

      <form className="d-flex w-100 flex-column gap-3" onSubmit={form.handleSubmit(onSubmit)}>
        <div className="form-floating">
          <input
            type="text"
            className="form-control"
            readOnly
            {...form.register("redirectUri")}
          />
          <label>Redirect URI</label>
        </div>

        <button type="submit" className="btn btn-primary form-control" disabled={isSubmitting || !isValid}>
          Generate OAuth URL
        </button>
      </form>
    </>
  )
}
